import { supabase } from '../../../lib/supabase';
import { StripeServiceError, STRIPE_ERROR_MESSAGES } from '../errors/types';
import { validateAuthSession } from '../../../utils/auth/validation';
import type { StripeCheckoutResponse, StripeError } from '../types';

export async function createCheckoutSession(
  priceId: string,
  options?: {
    promoCode?: string;
  }
): Promise<StripeCheckoutResponse> {
  try {
    // Validate auth session
    const session = await validateAuthSession();

    if (!session?.access_token) {
      throw new StripeServiceError(STRIPE_ERROR_MESSAGES.AUTH_REQUIRED);
    }

    const { data, error } = await supabase.functions.invoke('create-stripe-checkout', {
      body: {
        priceId,
        promoCode: options?.promoCode,
        successUrl: `${window.location.origin}/prestige-club`,
        cancelUrl: `${window.location.origin}/login`
      },
      headers: new Headers({
        Authorization: `Bearer ${session.access_token}`,
        'Content-Type': 'application/json'
      })
    });

    if (error || data?.error) {
      const stripeError = data?.error as StripeError;
      if (stripeError?.message?.includes('Expired API Key')) {
        throw new StripeServiceError(STRIPE_ERROR_MESSAGES.SERVICE_UNAVAILABLE);
      }
      throw new StripeServiceError(
        error?.message === 'Unauthorized' 
          ? STRIPE_ERROR_MESSAGES.AUTH_REQUIRED 
          : STRIPE_ERROR_MESSAGES.CHECKOUT_FAILED
      );
    }

    if (!data?.url) {
      throw new StripeServiceError(STRIPE_ERROR_MESSAGES.CHECKOUT_FAILED);
    }

    return { url: data.url };
  } catch (error) {
    console.error('Stripe checkout error:', error);
    throw error instanceof StripeServiceError ? error : new StripeServiceError(STRIPE_ERROR_MESSAGES.DEFAULT);
  }
}